import Box, { type BoxProps } from '@mui/material/Box';
import type { ReactNode } from 'react';

type ListRootProps = {
  children: ReactNode;
  dataTest?: string;
  sx?: BoxProps['sx'];
};

export const ListRoot = ({ children, dataTest = 'list-root', sx }: ListRootProps) => (
  <Box
    data-test={dataTest}
    sx={[
      {
        border: '1px solid',
        borderColor: 'divider',
        position: 'relative',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Box>
);
